import { createSelector } from "@reduxjs/toolkit"

import type { RootState } from "@/store/store"

const selectMeetingProfilesMap = (state: RootState) =>
  state.meetingProfiles.meetingProfiles

export const selectMeetingProfile = (roomId: string) =>
  createSelector(
    selectMeetingProfilesMap,
    (meetingProfiles) => meetingProfiles[roomId]?.meetingProfile ?? null,
  )

export const selectMeetingProfileLastUpdated = (roomId: string) =>
  createSelector(
    selectMeetingProfilesMap,
    (meetingProfiles) => meetingProfiles[roomId]?.lastUpdated ?? null,
  )
